import React, { useState } from "react";
import '../styles/Form.css'
import FormInput from "./FormInput";
import FormRow from "./FormRow";
import PatientDetail from "./PatientDetail";
import { Api } from "../api/Api";
import { showToast } from "../helpers/Helper";
import { Button, Input, Modal, Skeleton, Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import QuestionList from "./QuestionList";
import TextArea from "antd/es/input/TextArea";

const Form = (props) => {
    const [patientDetail, setPatientDetail] = useState(null);
    const [questions, setQuestions] = useState([]);
    const [isconfirmed, setIsconfirmed] = useState(false);
    const [mrn, setMrn] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [suggestion, setSuggestion] = useState(null);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [otp, setOtp] = useState(null);
    const [showOtpConfirmation, setShowOtpConfirmation] = useState(false);
    const [confirming, setConfirming] = useState(false);
    const searchPatient = () => {
        if (mrn==='' || !mrn) {
            showToast('error', 'MRN number is mandatory.')
            return;
        }
        setIsLoading(true);
        setIsButtonLoading(true);
        Api.get(`/api/mobileloadpatientkioskinfo?mrno=${mrn}&fromfeedback=true`).then((resp) => {
            if (resp.status === 200) {
                if (resp.data.patient_detials.length > 0) {
                    const formattedPatient = { ...resp.data.patient_detials[0],mrn:mrn }
                    setPatientDetail(formattedPatient);
                    const formattedQuestions = (resp.data.feedback_questions || []).map(q => ({
                        ...q,
                        rating: '', 
                        remarks: '' 
                    }));

                    setQuestions(formattedQuestions);
                } else {
                    showToast('error','No patients found');
                }
            }
            setIsLoading(false);
            setIsButtonLoading(false);
        }).catch((e) => {
            setIsLoading(false);
            setIsButtonLoading(false);
        })
    }

    const sendOtp = () => {
        setIsSubmitting(true);
        Api.get(`/registration/sendFeedbackOtp?patientId=${patientDetail.patient_id}`).then((resp) => {
            if (resp.status===200) {
                if (resp.data.status==='success') {
                    setShowOtpConfirmation(true);
                } else {
                    showToast('error', 'Failed to send OTP');
                }
            }
            setIsSubmitting(false);
        }).catch((e) => {
            showToast('error', 'Failed to send OTP');
            setIsSubmitting(false);
        })
    }

    const onSubmit = () => {
        debugger;
        if (!confirming) {
            setConfirming(true);
            Api.post(`/registration/Apisavefeedback?patientid=${patientDetail.patient_id}&visitId=${patientDetail.visit}`,
                { feedbacklist: questions, patientsuggestion: suggestion, convert:false,otp:otp }).then((resp) => {
                if (resp.status===200) {
                    console.log(resp);
                    if (resp.data.response==='Success') {
                        props.onsuccess(patientDetail);
                    } else {
                        showToast('error',resp.data.message);
                    }
                } else if(resp.status===404){
                    showToast('error', 'Failed to connect to server, Check your connection');
                } else {
                    showToast('error', 'Unknown problem occured');
                }
                setConfirming(false);
            }).catch((e) => {
                showToast('error', 'Unknown problem occured');
                setConfirming(false);
            })
        } else {
            showToast('info','Request pending.')
        }
    }
    return (
        <div className="form-container">
            <div className="title-container">
                <div className="main-title">
                    <span>Patient Feedback Form</span>
                </div>
                <div className="sub-title">
                    <span>Help us treat you better</span>
                </div>
            </div>
            <div className="form-fields">
                {isconfirmed ? <></> :
                    <FormRow>
                        <FormInput label="MRN" placeholder="Enter your MRN number" isButtonLoading={isButtonLoading} disabled={isconfirmed} buttonLabel="Search" onButtonClick={() => { searchPatient(); }} value={mrn} onChange={(e)=>{setMrn(e.target.value.toUpperCase())}}/>
                    </FormRow>
                }
                {isLoading ? 
                    <div className="loading-div">
                        <Skeleton active />
                    </div>
                    :
                    <>{patientDetail ?
                        <PatientDetail onconfirm={() => { setIsconfirmed(true); }} patientDetail={patientDetail} isconfirmed={isconfirmed} /> : <></>
                    }</>
                }
                {isconfirmed ? <>
                    <QuestionList setRating={setQuestions} questions={questions} />
                    <div className="additional-suggestion">
                        <div className="form-label">
                            Is there anything you want us to improve?
                        </div>
                        <TextArea value={suggestion} onChange={(e) => setSuggestion(e.target.value)} placeholder="Enter your suggestions"
                            autoSize={{ minRows: 3, maxRows: 5 }} />
                    </div>
                    </> :
                    <></>
                }
                {isconfirmed ?
                    <div className="submit-container">
                        <Button style={{ backgroundColor: '#5f0a10', color: 'white' }} onClick={() => { sendOtp(); }}>{isSubmitting ? <Spin indicator={<LoadingOutlined spin />} size="small" /> :'Submit'}</Button>
                    </div> : <></>
                }
            </div>
            <div className="branding">Powered by Life HIS</div>
            <Modal open={showOtpConfirmation} footer={null} closable={true} maskClosable={false} onCancel={() => { setShowOtpConfirmation(false); }}>
                <div className="otp-confirmation">
                    <div className="otp-title-text">
                        Enter OTP
                    </div>
                    <div className="otp-sub-title">
                        A 6 digit OTP has been sent to your registered mobile number
                    </div>
                    <Input value={otp} onChange={(e) => { setOtp(e.target.value); }} placeholder="Enter One-Time-Passowrd" />
                    <div className="otp-submit-btn-container">
                        <Button onClick={()=>{sendOtp()}} style={{margin:'0 5px 0 0'}}>
                            {isSubmitting ? <Spin></Spin> : 'Re-send'}
                        </Button>
                        <Button onClick={() => { onSubmit() }} style={{ backgroundColor: '#5f0a10', color: 'white' }}>
                            {confirming ? <Spin></Spin> : 'Confirm'}
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}
export default Form;